<!--Header-->
<div class="modal-header text-center" style="color: white;background-color: #0d47a1">
  <h4 class="modal-title w-100">{{x_titulo}}</h4>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
    <span aria-hidden="true" class="white-text">&times;</span>
  </button>
</div>
<div class="modal-body">
  <mdb-card>
        <mdb-card-body>
            <div class="form-row mb-3">
                <div class="col-3">Numero de Firmante:</div>
                <div class="col-9">
                  <input mdbInput type="text" maxlength="100" readonly class="form-control" [(ngModel)]="n_secuencia">
                </div>
            </div>
            <div class="form-row mb-3">
              <div class="col-3">Firmante Asignado:</div>
              <div class="col-9">
                  <select class="browser-default custom-select" [(ngModel)]="detFirmanteE.c_usuario" (change)="onUsuarioChange()">
                      <option value="0" selected>Seleccione</option>
                      <option *ngFor="let listUser of listUsuarios" [value]="listUser.c_usuario">{{listUser.x_nombres}} {{listUser.x_ape_pat}} {{listUser.x_ape_mat}}</option>
                  </select>
              </div>
            </div>
            <div class="form-row mb-3">
              <div class="col-3">Oficina:</div>
              <div class="col-9">
                <input mdbInput type="text" maxlength="100" readonly class="form-control" [(ngModel)]="x_oficina">
              </div>
          </div>
        </mdb-card-body>
</mdb-card>
</div>
<br>
<!--Footer-->
<div class="modal-footer justify-content-center">
<button mdbBtn type="button" (click)="onGrabar()" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
    <mdb-icon fas icon="save" class="mr-1"></mdb-icon>AGREGAR</button>
  </div>
